import React from "react";
import { FeatureIconContainer } from "../components/features/feature-icon-container";
import { IconReceiptFilled } from "@tabler/icons-react";
import { Heading } from "../components/ui/heading";
import { Subheading } from "../components/ui/subheading";
import { Separator } from "../components/ui/separator";
import { Link } from "react-router-dom";
import { HoverBorderGradient } from "../components/animations/hover-border-gradient";
import { HiArrowRight } from "react-icons/hi2";
import Beam from "../components/beam";

const HowItWorts = () => {
  return (
    <div>
      <div className="relative z-20" data-aos="fade-down">
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <IconReceiptFilled className="h-6 w-6 text-fuchsia-700" />
        </FeatureIconContainer>
        <Heading className="mt-4">How does it work?</Heading>
        <Subheading className="text-center max-w-lg mx-auto">
          It’s a straightforward path to become an WhizManage Affiliate
        </Subheading>
      </div>
      <div className="container mt-20 mx-auto md:px-20 flex flex-col md:flex-row max-w-48 md:max-w-max items-center justify-between gap-20 md:gap-8">
        <div className="flex flex-col justify-center items-center">
          <img
            className="mix-blend-color-burn"
            src={
              window.siteUrl +
              `/wp-content/plugins/innovative-design/public/gifs/click.gif`
            }
            alt="Description of the image"
          />
          <p className="text-fuchsia-100 text-xl text-center">
            Join the program
          </p>
        </div>
        <div className="w-full relative">
          <Beam showBeam className="-top-0.5 block max-md:hidden" />
          <hr className="border-pink-600 w-full mx-8 max-md:!rotate-90" />
          <Beam showBeam className="top-0.5 block max-md:hidden" />
        </div>
        <div className="flex flex-col justify-center items-center">
          <img
            className="mix-blend-color-burn"
            src={
              window.siteUrl +
              `/wp-content/plugins/innovative-design/public/gifs/promotion.gif`
            }
            alt="Description of the image"
          />
          <p className="text-fuchsia-100 text-xl text-center">Promote Make</p>
        </div>
        <div className="w-full relative">
          <Beam showBeam className="-top-0.5 block max-md:hidden" />
          <hr className="border-fuchsia-600 w-full mx-8 max-md:!rotate-90" />
          <Beam showBeam className="top-0.5 block max-md:hidden" />
        </div>
        <div className="flex flex-col justify-center items-center">
          <img
            src={
              window.siteUrl +
              `/wp-content/plugins/innovative-design/public/gifs/money-bag.gif`
            }
            className="mix-blend-color-burn"
            alt="Description of the image"
          />
          <p className="text-fuchsia-100 text-xl text-center">Earn rewards</p>
        </div>
      </div>
      <div className="flex items-center gap-4 justify-center my-20 relative z-10 dark">
        <Link
          activeClass="active"
          spy={true}
          to="/affiliate-home/affiliate-register/"
          smooth="easeInOutQuint"
          duration={1000}
          delay={200}
          offset={20}
        >
          <HoverBorderGradient
            containerClassName="rounded-full"
            as="button"
            className="dark:bg-black bg-white text-black dark:text-white flex items-center space-x-2 group"
          >
            <span>Get started</span>
            <HiArrowRight className="text-white group-hover:translate-x-1 stroke-[1px] h-3 w-3 mt-0.5 transition-transform duration-200" />
          </HoverBorderGradient>
        </Link>
      </div>
    </div>
  );
};

export default HowItWorts;
